export const NETWORK_ERR = 'NETWORK_ERR'
export const AUTHENTICATED_ERR = 'AUTHENTICATED_ERR'
export const SYSTEM_ERR = 'SYSTEM_ERR'

export const POP_NOTIFY = 'POP_NOTIFY'
export const PUSH_NOTIFY = 'PUSH_NOTIFY'